module.exports = new __parcel__URL__("is-new-tag.a910d1fc.html").toString();